import { useRouter } from "@/lib/nav";
import { useCallback, useState } from "react";
import { toast } from "sonner";

import { settleRedirect } from "@/lib/redirect-error";

// 기록 액션 결과 — moved 는 이동(redirect·401 → /login)이라 부른 쪽이 뒤 작업(다음 장 올리기 등)을 멈춘다.
export type RecordOutcome = "done" | "failed" | "moved";

// 기록 액션 부르기 — 실패는 토스트, 성공은 done 뒤 새로고침 · 이동은 settleRedirect 가 처리하고 moved · 404·라우터 신호는 다시 던진다.
export const useRecordAction = () => {
  const router = useRouter();
  const [pending, setPending] = useState(false);

  const run = useCallback(
    async (
      fallback: string,
      call: () => Promise<{ ok: boolean; message?: string }>,
      done?: () => void
    ): Promise<RecordOutcome> => {
      setPending(true);
      try {
        const result = await call();
        if (!result.ok) {
          toast.error(result.message ?? fallback);
          return "failed";
        }
        done?.();
        router.refresh();
        return "done";
      } catch (error) {
        if (settleRedirect(error)) return "moved";
        toast.error(fallback);
        return "failed";
      } finally {
        setPending(false);
      }
    },
    [router]
  );

  return { pending, run };
};
